var $815366f02abc6194$exports = {};
$815366f02abc6194$exports = {
    "loading": `Carregando...`,
    "placeholder": `Selecionar\u{2026}`
};


export {$815366f02abc6194$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
